interface ServicesProps {
  city: string;
}

export function Services({ city }: ServicesProps) {
  const services = [
    {
      title: 'Fenêtres PVC',
      image: 'https://public.readdy.ai/ai/img_res/df88a2abec14baa48d43aedf97f6aab5.jpg',
      description: `Expert en réparation de fenêtres PVC à ${city}. Nous intervenons sur tous types de fenêtres PVC : oscillo-battantes, coulissantes, fixes ou à soufflet.`,
      interventions: [
        'Remplacement de vitrages cassés ou fissurés',
        'Changement de joints d\'étanchéité usés',
        'Réparation de mécanismes d\'ouverture',
        'Remplacement de poignées et serrures',
        'Ajustement et réglage des vantaux',
        'Rénovation complète du système'
      ]
    },
    {
      title: 'Fenêtres Aluminium',
      image: 'https://readdy.ai/api/search-image?query=sleek%20modern%20aluminum%20window%20frame%20with%20metallic%20silver%20grey%20finish%20and%20contemporary%20minimalist%20design%20installed%20in%20modern%20coastal%20architecture%20professional%20interior%20photography%20showing%20premium%20quality%20material%20ideal%20for%20residential%20window%20installation%20repair%20and%20maintenance%20services&width=600&height=400&seq=arcachon-alu-win-2025&orientation=landscape',
      description: `Spécialiste de la réparation de fenêtres aluminium à ${city}. Intervention rapide sur toutes marques : Technal, Schüco, Reynaers, K-Line.`,
      interventions: [
        'Réparation de systèmes coulissants',
        'Remplacement de double vitrage',
        'Changement de joints et brosses',
        'Réparation de crémones et ferrures',
        'Traitement anti-corrosion',
        'Amélioration de l\'isolation thermique'
      ]
    },
    {
      title: 'Fenêtres Bois',
      image: 'https://readdy.ai/api/search-image?query=elegant%20natural%20wooden%20window%20frame%20with%20beautiful%20rich%20wood%20grain%20texture%20and%20traditional%20expert%20craftsmanship%20installed%20in%20classic%20coastal%20home%20interior%20warm%20ambient%20lighting%20showing%20authentic%20quality%20material%20perfect%20for%20heritage%20window%20restoration%20repair%20and%20renovation%20services%20architectural%20detail&width=600&height=400&seq=arcachon-wood-win-2025&orientation=landscape',
      description: `Artisan spécialisé dans la réparation de fenêtres bois à ${city}. Nous restaurons et réparons vos fenêtres en bois avec soin et expertise.`,
      interventions: [
        'Traitement du bois contre l\'humidité',
        'Réparation de bois endommagé',
        'Remplacement de vitrage ancien',
        'Rénovation de peinture et lasure',
        'Changement de quincaillerie',
        'Amélioration de l\'étanchéité'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Nos Services de Réparation à {city}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Intervention rapide et professionnelle sur tous types de fenêtres. 
            Devis gratuit et garantie sur toutes nos réparations.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 w-full overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                <ul className="space-y-2">
                  {service.interventions.map((intervention, idx) => (
                    <li key={idx} className="flex items-start text-sm text-gray-700">
                      <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
                      <span>{intervention}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}